import { call, put, takeLatest } from 'typed-redux-saga'
import { errorHandler, FeedbackWidgetNS, feedbackApi, feedbackWidgetSlice } from 'Modules'

function* sendWidgetFeedback(action: FeedbackWidgetNS.SendWidgetFeedback) {
	try {
		const { callback, data } = action.payload
		yield* call(feedbackApi.sendFeedback, data)
		callback?.()
		yield* put(feedbackWidgetSlice.actions.setFeedbackWidget(null))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* feedbackWidgetSaga() {
	yield* takeLatest(feedbackWidgetSlice.actions.sendWidgetFeedback.type, sendWidgetFeedback)
}
